<template>
  <portal to="modal">
    <modal-card :ctrl="IDE.modals.exitGroup">
      <div slot="body">
        <h4 class="title has-text-centered is-text-rlarge"><b>是否要退出当前课堂?</b></h4>
        <div class="buttons is-hcenter">
          <button @click="$emit('exit')"
                  class="button is-outlined is-danger is-rounded">退出课堂
          </button>
          <button @click="IDE.modals.exitGroup.active = false"
                  class="button is-outlined is-link is-rounded">继续学习
          </button>
        </div>
      </div>
    </modal-card>
  </portal>
</template>

<script>
const IDE = window['IDE']

export default {
  props: { active: {} },
  data () {
    return {
      IDE
    }
  },
  methods: {
    exit () {
      this.$emit('exit')
      IDE.modals.exitGroup.active = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.title {
  font-size 1.5rem
  border-bottom 1px solid #dddddd
  padding 1rem
  margin 0 0 1.5rem 0
}
</style>
